import Vue from 'vue';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import '../../../../filters';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'SupportServicesSchedules',
  mixins: [validationMixin],
  components: {
    ScheduleComp: require('./schedule.vue').default,
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      activityId: -1,
      schedules: [],
      supportServices: [],
      stations: [],
      usageTypes: [],
      periodTypes: [],
      supportServiceTypes: [],
      teams: [],
      deleteConfirmMessage: '',
      bScheduleDialog: false,
      bConfirmDialog: false,
      editingSchedule: {},
      editingScheduleClone: {},
      message: '',
    }
  },
  validations: {
    maintenanceValue: {
      required
    },
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('support_services_schedules_updated', this.init);
    this.init();
  },
  methods: {
    formatMoney(number, decPlaces, decSep, thouSep) {
      decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
        decSep = typeof decSep === "undefined" ? "." : decSep;
      thouSep = typeof thouSep === "undefined" ? "," : thouSep;
      var sign = number < 0 ? "-" : "";
      var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
      var j = (j = i.length) > 3 ? j % 3 : 0;

      return sign +
        (j ? i.substr(0, j) + thouSep : "") +
        i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
        (decPlaces ? decSep + Math.abs(number - parseInt(i)).toFixed(decPlaces).slice(2) : "");
    }, //this.formatMoney(item.closingBalance, 2, '.', ',');
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        this.activityId = this.dataObj.activityId;
        this.dataObj.appData.supportServicesSchedules.forEach(p => {
          if (!p.uuid || p.uuid === null || p.uuid.length === 0)
            p.uuid = uuidv4();
          p.periodDuration = this.calculateDuration(p.periodEnd, p.periodBegin);
        });
        if (this.dataObj.appData.supportServicesSchedules)
          this.schedules = this.dataObj.appData.supportServicesSchedules;
        else
          this.dataObj.appData.supportServicesSchedules = [];
        this.supportServices = this.dataObj.appData.supportServices;
        this.stations = this.dataObj.appData.stations;
        this.usageTypes = this.dataObj.appData.usageTypes;
        this.periodTypes = this.dataObj.appData.periodTypes;
        this.teams = this.dataObj.appData.teams;
        this.supportServiceTypes = this.dataObj.appData.supportServiceTypes;
        console.log("suprt serv. dataObj", this.dataObj);
      });
    },
    calculateDuration(start, end) {
      //find difference and cinvert it to mis
      let t = (Date.parse(start) - Date.parse(end)) / 1000 / 60;
      return t.toString();
    },
    addSchedule() {
      this.editingScheduleClone = {
        isMultiple: false,
        selection: [],
        id: 0,
        applicationId: 0,
        activityId: 0,
        supportServiceId: 0,
        supportService: '',
        supportServiceTypeId: -1,
        supportServiceType: '',
        usageTypeId: 0,
        usageType: '',
        periodTypeId: !this.dataObj.appData.schedulesPeriodBegin && !this.dataObj.appData.schedulesPeriodEnd ? 2 : 1,
        periodType: '',
        periodDate: this.dataObj.appData.schedulesPeriodBegin,
        periodBegin: this.dataObj.appData.schedulesPeriodBegin,//moment(this.dataObj.schedulesPeriodBegin).format(),
        periodEnd: this.dataObj.appData.schedulesPeriodEnd,//moment(this.dataObj.schedulesPeriodEnd).format(),
        periodDuration: '',
        stationId: this.dataObj.appRecord.stationId,
        comment: '',
        readOnly: this.dataObj.readOnly,
        uuid: uuidv4()
      };
      this.editingScheduleClone.supportServices = this.supportServices;
      this.editingScheduleClone.supportServiceTypes = this.supportServiceTypes;
      this.editingScheduleClone.stations = this.stations;
      this.editingScheduleClone.teams = this.teams;
      this.editingScheduleClone.usageTypes = this.usageTypes;
      this.editingScheduleClone.periodTypes = this.periodTypes;
      this.bScheduleDialog = true;
    },
    editSchedule(item) {
      this.editingSchedule = item;
      this.editingScheduleClone = JSON.parse(JSON.stringify(item));
      this.editingScheduleClone.supportServices = this.supportServices;
      this.editingScheduleClone.supportServiceTypes = this.supportServiceTypes;
      this.editingScheduleClone.stations = this.stations;
      this.editingScheduleClone.teams = this.teams;
      this.editingScheduleClone.usageTypes = this.usageTypes;
      this.editingScheduleClone.periodTypes = this.periodTypes;
      this.editingScheduleClone.readOnly = this.dataObj.readOnly;
      this.editingScheduleClone.stationId = this.dataObj.appRecord.stationId;
      this.editingScheduleClone.isMultiple = false;
      this.editingScheduleClone.selection = [];
      this.bScheduleDialog = true;
    },
    removeConfirm(item) {
      this.deleteConfirmMessage = this.$t('omApplication.DeleteSchedule') + ' [' + item.id + '. ' + item.supportService + '] ?';
      this.editingSchedule = item;
      this.bConfirmDialog = true;
    },
    removeSchedule() {
      this.dataObj.appData.supportServicesSchedules = this.dataObj.appData.supportServicesSchedules.filter(p => p.uuid !== this.editingSchedule.uuid);
      this.schedules = this.dataObj.appData.supportServicesSchedules;
    },
    saveSchedule() {
      console.log("editClone", this.editingScheduleClone);
      //error checks
      if (this.editingScheduleClone == 2 && (this.editingScheduleClone.periodBegin == null || this.editingScheduleClone.periodBegin == '' || this.editingScheduleClone.periodEnd == null || this.editingScheduleClone.periodEnd == '')) {
        this.$alertMsg(this.$t('messages.completeStarEndTime'), 3);
        return;
      }

      if (this.editingScheduleClone.periodDuration <= 0 && this.editingScheduleClone == 2) {
        this.$alertMsg(this.$t('messages.wrongStarEndTime'), 3);
        return;
      }

      //console.log("to save", this.editingScheduleClone);
      this.editingScheduleClone.periodEnd = this.convertDate(this.editingScheduleClone.periodEnd)
      this.editingScheduleClone.periodDate = this.convertDate(this.editingScheduleClone.periodDate)
      this.editingScheduleClone.periodBegin = this.convertDate(this.editingScheduleClone.periodBegin)

      this.dataObj.appData.supportServicesSchedules = this.dataObj.appData.supportServicesSchedules.filter(p => p.uuid !== this.editingScheduleClone.uuid);
      const isMultiple = this.editingScheduleClone.isMultiple;
      const selection = this.editingScheduleClone.selection;
      delete this.editingScheduleClone.supportServices;
      delete this.editingScheduleClone.supportServiceTypes;
      delete this.editingScheduleClone.stations;
      delete this.editingScheduleClone.teams;
      delete this.editingScheduleClone.readOnly;
      delete this.editingScheduleClone.usageTypes;
      delete this.editingScheduleClone.periodTypes;
      delete this.editingScheduleClone.isMultiple;
      delete this.editingScheduleClone.selection;
      
      if (isMultiple === false) {
        //console.log("serv", this.dataObj.appData.supportServices.filter(s => s.id == this.editingScheduleClone.supportServiceId && s.supportServiceTypeId == this.editingScheduleClone.supportServiceTypeId));
        this.editingScheduleClone.supportServiceTypeId = this.dataObj.appData.supportServices.filter(s => s.id == this.editingScheduleClone.supportServiceId && s.supportServiceTypeId == this.editingScheduleClone.supportServiceTypeId)[0].supportServiceTypeId;
        this.editingScheduleClone.supportServiceType = this.dataObj.appData.supportServices.filter(s => s.id == this.editingScheduleClone.supportServiceId && s.supportServiceTypeId == this.editingScheduleClone.supportServiceTypeId)[0].supportServiceType;
        this.dataObj.appData.supportServicesSchedules.push(this.editingScheduleClone);
      }
      else {
        selection.forEach(p => {
          const schedule = JSON.parse(JSON.stringify(this.editingScheduleClone));
          schedule.supportServiceId = p.id;
          schedule.applicationId = parseInt(this.appId);
          schedule.periodDuration = this.editingScheduleClone.periodDuration;
          schedule.activityId = this.activityId;
          schedule.periodTypeId = parseInt(schedule.periodTypeId);
          schedule.usageTypeId = parseInt(schedule.usageTypeId);
          //console.log("p", p);
          //console.log("supp serv", supportService);
          schedule.supportServiceTypeId = parseInt(p.typeId);
          schedule.supportService = p.name;
          schedule.uuid = uuidv4();
          this.dataObj.appData.supportServicesSchedules.push(schedule);
        });
      }
      this.schedules = this.dataObj.appData.supportServicesSchedules;
      this.bScheduleDialog = false;
      this.$forceUpdate();
    },
    convertDate(val) {

      let valDate = new Date(val);
      let perDate = new Date(this.editingScheduleClone.periodDate);

      //construct final date in sql datetime format from period date base and hours from val
      let date = perDate.getFullYear() + '-' +
        ('00' + (perDate.getMonth() + 1)).slice(-2) + '-' +
        ('00' + perDate.getDate()).slice(-2) + 'T' +
        ('00' + valDate.getHours()).slice(-2) + ':' +
        ('00' + valDate.getMinutes()).slice(-2) + ':' +
        '00';

      return date;
    },
    closeDialog() {
      this.bScheduleDialog = false;
    },
  },

}

